import { z } from 'zod';

export const RECAPTCHA_SITE_KEY = '6LffdKgpAAAAABOoic5s5gbGdb9yyBbWAXUVV6wt';

export const INPUT_LIMITS = {
	FIRST_LAST_NAME_MAX: 15,
	PASSWORD_MIN: 6,
	PASSWORD_MAX: 20,
	ORGANIZATION_MAX: 100,
	PRODUCT_KEY_MAX: 15,
	PARTICIPANT_NAME_MAX: 25,
	GROUP_NAME_MAX: 25,
	CPDECK_NAME_MAX: 50,
	CPDECK_FOLDER_NAME_MAX: 25,
};

export const PROFESSIONS = [
	{ label: 'Please select', value: 'placeholder' },
	{ label: 'Teacher', value: 'teacher' },
	{ label: 'Trainer', value: 'trainer' },
	{ label: 'Corporate Professional', value: 'corporateProfessional' },
	{ label: 'Student', value: 'student' },
	{ label: 'Other', value: 'other' },
];

export const LEAD_SOURCES = [
	{ label: 'Please select', value: 'placeholder' },
	{ label: 'Online search', value: 'onlineSearch' },
	{ label: 'My organization or colleagues', value: 'organizationOrColleagues' },
	{ label: 'Webinar or training', value: 'webinarTraining' },
	{ label: 'Social media', value: 'socialMedia' },
];

export const STUDENT_DEVICE_USAGE = [
	{ label: 'Please select', value: 'placeholder' },
	{ label: 'Students always use learning devices', value: 'always' },
	{ label: 'Sometimes only', value: 'sometimes' },
	{ label: 'No student devices are allowed', value: 'never' },
];

export const YES_NO_SELECT = [
	{ label: 'Yes', value: true },
	{ label: 'No', value: false },
];

export const emailResolver = () => {
	return z.string().min(1, { message: 'Email is required' }).email({ message: 'Please enter a valid email address' });
};

export const passwordResolver = () => {
	return z
		.string()
		.min(1, 'Password is required')
		.min(INPUT_LIMITS.PASSWORD_MIN, {
			message: `Password must be at least ${INPUT_LIMITS.PASSWORD_MIN} characters long`,
		});
};

// wmv: with metacharacter validation (use short form to type easily)
export const wmv = (schema: any, message: string = 'Invalid characters') => {
	return schema.refine(
		(value: any) => {
			const selfClosingTagRegex = /<\w+\s*\/>/; // <xxx />
			const normalTagRegex = /<\w+.*?>.*?<\/\w+>/; // <xxx ... /xxx>
			const isSelfClosingTag = selfClosingTagRegex.test(value);
			const isNormalTag = normalTagRegex.test(value);
			const allowed = !isSelfClosingTag && !isNormalTag;
			// console.log('Value: ', value, ' | Allowed: ', allowed);
			return allowed;
		},
		{ message },
	);
};
